import { PAYMENT_SUBMIT_BUTTON_ID } from '@src/global/App/constants/constants';
import observeElementMutation from '@src/global/utils/mutationObserver';
import { useEffect, useState } from 'react';

// Attribute to get if WPS Form is filled
const WPS_PAYMENT_FORM_BUTTON_ATTRIBUTE = 'disabled';

export const useWpsPaymentForm = () => {
  const [isPaymentFormFilled, setIsPaymentFormFilled] = useState(false);

  useEffect(() => {
    const button = document.getElementById(PAYMENT_SUBMIT_BUTTON_ID);
    if (button) {
      const submitFormBtnObserver = new MutationObserver(
        observeElementMutation((isDisabled) => {
          setIsPaymentFormFilled(!isDisabled);
        }, WPS_PAYMENT_FORM_BUTTON_ATTRIBUTE)
      );

      submitFormBtnObserver.observe(button, { attributes: true });
    }
  }, []);

  const scrollToPaymentForm = () => {
    const form = document.querySelector('#payment-form-anchor');

    form?.scrollIntoView({ block: 'start' });
  };

  const submitPaymentForm = () => {
    const button = document.getElementById(PAYMENT_SUBMIT_BUTTON_ID);
    button.click();
  };

  return {
    scrollToPaymentForm,
    submitPaymentForm,
    isPaymentFormFilled,
  };
};
